import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  openAreaModal () {
    if (typeof window.gtagEvent === 'function') {
      window.gtagEvent('event', '', 'area::map_search_banner_tap')
    }
    window.dispatchEvent(
      new CustomEvent('open-condition-search-modal', {
        detail: { modalIndex: '0' },
      }),
    )
  }
}
